import styled from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const BodyWrapper = styled.div<{ $isBack?: boolean }>`
  width: 100%;
  flex: 1;
  ${flexColumn};
  gap: 15px;
  padding-bottom: 24px;
  padding-right: 40px;
  padding-left: 40px;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    gap: 10px;
    padding-right: 0;
    padding-left: 0;
    padding-bottom: calc(
      env(safe-area-inset-bottom) +
        ${({ $isBack }) => ($isBack ? '122px' : '89px')}
    );
  }
`;
